
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"144","height":"48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".5","fill":"#fff"}},[_c('path',{attrs:{"d":"M84.766 32.334c-4.469-.02-6.825-3.092-6.825-7.657V9.6h4.586v4.605h2.758v4.111h-2.758v6.398c0 2.53 1.148 3.48 3.44 3.34 1.218 2.48 2.94 3.799 2.94 3.799-2.094.597-4.141.48-4.141.48z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M63.034 30.569c1.352 1.402 3.12 2.103 5.199 2.103 4.713 0 8.526-4.24 8.526-9.463 0-5.187-3.777-9.428-9.15-9.428-5.406 0-9.184 4.24-9.184 9.428v15.19h4.61v-7.83zm0-7.36c0-2.804 2.046-5.082 4.575-5.082 2.53 0 4.576 2.173 4.576 5.082 0 2.944-2.046 5.188-4.576 5.188s-4.575-2.314-4.575-5.188zM100.467 32.288h4.333V23.28c0-5.223-3.778-9.499-9.15-9.499-5.406 0-9.184 4.276-9.184 9.499 0 5.186 3.848 9.392 8.56 9.392 2.15 0 4.09-.771 5.441-2.277v1.893zm-9.391-8.973c0-2.98 2.044-5.189 4.574-5.189s4.575 2.313 4.575 5.189c0 2.803-2.045 5.082-4.575 5.082-2.53 0-4.574-2.208-4.574-5.082zM48.288 32.791c5.017 0 9.122-4.073 9.122-9.528s-4.105-9.6-9.122-9.6c-5.018 0-9.088 4.145-9.088 9.6s4.07 9.528 9.087 9.528zm0-14.841c2.456 0 4.456 2.196 4.456 5.348 0 3.082-2 5.207-4.456 5.207-2.456 0-4.456-2.125-4.456-5.207 0-3.152 2-5.348 4.456-5.348z"}})])])
          )
        }
      }
    